<template>
  <div class="content-item">
    <border-radius
      :borderTypeFlag.sync="borderTypeFlag"
      :borderRadius.sync="borderRadius"
      :borderTopLeftRadius.sync="borderTopLeftRadius"
      :borderTopRightRadius.sync="borderTopRightRadius"
      :borderBottomRightRadius.sync="borderBottomRightRadius"
      :borderBottomLeftRadius.sync="borderBottomLeftRadius"
    />
  </div>
</template>

<script>
import { historyCombineWrap } from "utils/revork"
export default {
  props: {
    options: {
      type: Object
    }
  },
  computed: {
    borderTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("borderTypeFlag")) {
          if (
            ((this.borderTopLeftRadius === this.borderTopRightRadius) === this.borderBottomLeftRadius) ===
            this.borderBottomRightRadius
          ) {
            defaultType = 2
          }
        }
        // return this.checkAndSetPrimaryVal(this.options, "borderTypeFlag", "borderTypeFlag", defaultType)
        // 上面方法貌似是执行需要一定的时间，造成最开始还未写入值，进行点击 会出现问题
        return this.options.borderTypeFlag || defaultType
      },
      set(newVal) {
        this.$emit("update", "borderTypeFlag", newVal)
      }
    },
    borderRadius: {
      get() {
        const data = this.options //获取数据
        const dataMap = [
          "borderTopLeftRadius",
          "borderTopRightRadius",
          "borderBottomRightRadius",
          "borderBottomLeftRadius"
        ] //过滤工具数组
        return (
          data &&
          parseInt(
            dataMap.reduce((prevK, currK, currKIndex) => {
              if (currKIndex - 1 === 0) {
                return Number(data[prevK]) + Number(data[currK])
              } else {
                return prevK + Number(data[currK])
              }
            }) / dataMap.length
          )
        )
      },
      set(newVal) {
        historyCombineWrap(() => {
          this.$emit("update", "borderTopLeftRadius", newVal)
          this.$emit("update", "borderTopRightRadius", newVal)
          this.$emit("update", "borderBottomRightRadius", newVal)
          this.$emit("update", "borderBottomLeftRadius", newVal)
        })()
      }
    },
    borderTopLeftRadius: {
      get() {
        return this.options.borderTopLeftRadius
      },
      set(newVal) {
        this.$emit("update", "borderTopLeftRadius", newVal)
      }
    },
    borderTopRightRadius: {
      get() {
        return this.options.borderTopRightRadius
      },
      set(newVal) {
        this.$emit("update", "borderTopRightRadius", newVal)
      }
    },
    borderBottomRightRadius: {
      get() {
        return this.options.borderBottomRightRadius
      },
      set(newVal) {
        this.$emit("update", "borderBottomRightRadius", newVal)
      }
    },
    borderBottomLeftRadius: {
      get() {
        return this.options.borderBottomLeftRadius
      },
      set(newVal) {
        this.$emit("update", "borderBottomLeftRadius", newVal)
      }
    }
  }
}
</script>
